module.exports = __webpack_public_path__ + "img/number-four.7807042e.png";